import React from "react";

import Slider from "react-slick";

const Testimonials = ({ classicHeader, darkTheme }) => {
  const reviews = [
    {
      name: "Phil Johnston",
      position: "Director, IT, Enterprise Arch",
      src: "images/testimonial/phil-johnston.jpeg",
      desc: "Con worked as a directed report for me during his time in corporate data and integration. I would describe him as fast and accurate. During this time, he worked full-time hours while studying for his honors degree without any impact on his deliverables. He truly is a hard worker.",
      rating: 5,
    },
    {
      name: "Preetha Sekharan",
      position: "VP, Digital Strategy",
      src: "images/testimonial/preetha.jpeg",
      desc: "Con was part of the digital incubator at Unum as an integration specialist for an AI product. I found him enterprising, committed, and willing to take on challenges. I would recommend him as a valuable asset to any business.",
      rating: 5,
    },

    {
      name: "Ken Cregan",
      position: "Associate Partner",
      src: "images/testimonial/Ken_Cregan.jpeg",
      desc: "I found managing Con to be straightforward and simple. He was never afraid to speak his mind and displayed a great thirst for knowledge. He's one of the good ones.",
      rating: 5,
    },
    // {
    //   name: "Chris Tom",
    //   position: "User from UK",
    //   src: "images/testimonial/client-sm-4.jpg",
    //   desc: "I have used them twice now. Good rates, very efficient service and priced simply dummy text of the printing and typesetting industry quidam interesset his et. Excellent.",
    //   rating: 5,
    // },
  ];

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <section
      id="testimonial"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Testimonial
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            People who've worked with me
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}

        <Slider {...settings}>
          {reviews.length > 0 &&
            reviews.map((value, index) => (
              <div className="item" key={index}>
                <div
                  className={
                    " rounded p-5 " + (darkTheme ? "bg-dark" : "bg-light")
                  }
                >
                  <div className="d-flex align-items-center mt-auto mb-4">
                    <img
                      className="img-fluid rounded-circle border d-inline-block w-auto"
                      src={value.src}
                      alt=""
                    />
                    <p className="ms-3 mb-0">
                      <strong
                        className={
                          "d-block fw-600 " +
                          (darkTheme ? "text-white" : "text-dark")
                        }
                      >
                        {value.name}
                      </strong>
                      <span className="text-muted fw-500">
                        {" "}
                        {value.position}{" "}
                      </span>
                    </p>
                  </div>
                  <p
                    className={
                      " fw-500 mb-4 " + (darkTheme ? "text-white" : "text-dark")
                    }
                  >
                    “{value.desc}”
                  </p>
                  <span className="text-2">
                    {[...Array(value.rating)].map((value, i) => (
                      <i className="fas fa-star text-warning" key={i} />
                    ))}
                  </span>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
